import { sheetMetrics } from '../lib/docStyles';

const DocumentMeasureTree = ({
  items,
  renderHeader,
  renderFooter,
  setNodeRef,
  measureRef,
  landscape = false
}) => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed left-0 top-0 -z-10 opacity-0"
    style={{ width: sheetMetrics(landscape).contentWidth }}
    ref={measureRef}>
    <div ref={setNodeRef('__chrome', 'header-first')}>{renderHeader?.(0)}</div>
    <div ref={setNodeRef('__chrome', 'header-rest')}>{renderHeader?.(1)}</div>
    <div ref={setNodeRef('__chrome', 'footer')}>{renderFooter?.({ page: 1, pageCount: 1 })}</div>
    {items.map((block) => (
      <div key={block.key} className="flow-root" ref={setNodeRef(block.key, 'node')}>
        {block.table ? (
          <>
            <div className="flow-root" ref={setNodeRef(block.key, 'leading')}>
              {block.leading}
            </div>
            <div ref={setNodeRef(block.key, 'rows')}>{block.render({ ...block.table })}</div>
            <div ref={setNodeRef(block.key, 'header')}>
              {block.render({ ...block.table, groups: [], totals: undefined })}
            </div>
          </>
        ) : (
          block.node
        )}
      </div>
    ))}
  </div>
);

export default DocumentMeasureTree;
